/** Canonical Brand industry options (Super Admin Brands UI). */
export const DEFAULT_BRAND_INDUSTRIES = [
  "hospitality",
  "food-service",
  "retail",
  "fitness",
  "grocery",
  "convenience",
  "healthcare",
  "education",
  "entertainment",
  "automotive",
  "banking",
  "other",
] as const;

/**
 * Merge default industries with any already used on brands (and optional
 * session extras). Defaults keep their preferred order; extras sort A–Z.
 */
export function mergeIndustryOptions(
  ...extraLists: Array<Iterable<string | null | undefined> | null | undefined>
): string[] {
  const extras = new Set<string>();
  for (const list of extraLists) {
    if (!list) continue;
    for (const raw of list) {
      const value = String(raw || "").trim();
      if (!value) continue;
      if (
        !(DEFAULT_BRAND_INDUSTRIES as readonly string[]).includes(value)
      ) {
        extras.add(value);
      }
    }
  }
  return [
    ...DEFAULT_BRAND_INDUSTRIES,
    ...Array.from(extras).sort((a, b) => a.localeCompare(b)),
  ];
}

export function industrySelectOptions(industries: string[]) {
  return industries.map((industry) => ({
    label: industry,
    value: industry,
  }));
}
